import { COMPANY_TYPE_OPTIONS, type RootCompany } from "./rootCompany";

export interface RootCompaniesSearch {
  readonly page: number;
  readonly q?: string;
  readonly type?: RootCompany["type"];
}

export function parseRootCompaniesSearch(
  search: Record<string, unknown>,
): RootCompaniesSearch {
  const page = Number(search.page);
  return {
    page: Number.isSafeInteger(page) && page >= 1 ? page : 1,
    q: typeof search.q === "string" ? search.q.trim() || undefined : undefined,
    type: COMPANY_TYPE_OPTIONS.find((option) => option.value === search.type)
      ?.value,
  };
}
